import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import AdminLogin from './AdminLogin';
import CashierDashboard from './CashierDashboard';
import ProtectedAdminRoute from './ProtectedAdminRoute';
import HomePage from './HomePage';
import UserDashboard from './UserDashboard';
import UserEntry from './UserEntry';
import ReservationRequests from './ReservationRequests';
import WelcomePage from './WelcomePage';
import DocumentVerifyPage from './DocumentVerifyPage';

const MainRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/verify-document" element={<DocumentVerifyPage />} />

      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <App />
          </ProtectedAdminRoute>
        }
      />

      <Route
        path="/admin/reservations"
        element={
          <ProtectedAdminRoute>
            <ReservationRequests />
          </ProtectedAdminRoute>
        }
      />

      <Route path="/cashier" element={<CashierDashboard />} />
      <Route path="/user/:barcode" element={<UserDashboard />} />
      <Route path="/entry" element={<WelcomePage />} />
      <Route path="/entry/barcode" element={<UserEntry />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default MainRouter;
